module.exports = __webpack_public_path__ + "media/images/landing/illust/mac-holder-1e9ce90860c6d43f3004e7552f08b700.png";